// Filename: public/submitForm.js 
//
// Code written in public files is shared by your site's
// Backend, page code, and site code environments.
//
// Use public files to hold utility functions that can 
// be called from multiple locations in your site's code.

import {authorizationCode, generateAccessToken, postLead, accessAndInsert, getLeads} from 'backend/postLead.jsw';

// Colin: Here is where I will send the form data to the backend, and ultimately to ZohoCRM.
// This function is called by the button13_mouseIn() event.

// This public function is partly to minimize repetitive code on each page with a consultation form.
// This might also be a good place to include arguments that aren't directly from user input (e.g. 'Lead Source').
// I may also try to gather all the values into an object as early as possible, and just pass that one object along.

export function submitForm(_lastName, _company, _email, _phone, _notes, _page, _newsletterDecline) {
    // Colin: the authorizationCode() function needs to be called once (after generating a temporary grant token from ZohoCRM's API console) from the site's code to get the reusable refresh token from ZohoCRM.
    // After the one successful run we can comment it out and comment the accessAndInsert() function back in.
    // There's probably a clearer way to do this (e.g. maybe delete the zoho_refresh_token Secret via the manager, and add code so if zoho_refresh_token doesn't exist, run authorizationCode() and set a new secret via code. Otherwise, continue on with running accessAndInsert()).
    
    // authorizationCode().then(function(r) { console.log('Response with refresh token below:'); console.log(r); });

    console.log("Form Location: " + _page);

    return accessAndInsert(_lastName, _company, _email, _phone, _notes, _page, _newsletterDecline);
}

